import { OnInit, OnDestroy, Input } from '@angular/core'
import { Component, NgZone } from '@angular/core'
import { ConsoleLogger } from 'src/lib/console-logger'
import { MagliveApiClient } from 'src/lib/api-client/maglive-api-client'
import { AnimationItem } from 'lottie-web'
import { AnimationOptions } from 'ngx-lottie'
import { GiftAnimationReq } from 'src/lib/entity/gift-point'
import { GiftService } from 'src/lib/services/gift-service'

@Component({
  selector: 'maglive-gift-animation',
  templateUrl: './gift-animation.component.html',
  styleUrls: ['./gift-animation.component.scss'],
})
export class GiftAnimationComponent implements OnDestroy, OnInit {
  @Input() liveId: string
  @Input() liveStatus: string
  private nextAnimation: (gift: GiftAnimationReq) => void | null = null
  isFadeOut = false
  isAnimationProcessing = false
  private animationItem: AnimationItem
  private waitGiftQueue: GiftAnimationReq[] = []
  getUserIconURL = MagliveApiClient.getUserIconURL
  animationOptions: AnimationOptions = {
    // path: '',
    path: 'https://live.stg.mag2.com/data/gifts/animations/2/beer.json',
  }
  animationStyles: Partial<CSSStyleDeclaration> = {
    maxWidth: '130px',
  }

  giftMeta$ = this.giftService.giftMeta$
  giftInfo: GiftAnimationReq
  labelColor: string

  constructor(
    private ngZone: NgZone,
    private giftService: GiftService,
    private logger: ConsoleLogger
  ) {}

  ngOnInit() {}

  ngOnDestroy() {
    if (this.nextAnimation) {
      this.nextAnimation = null
      this.waitGiftQueue = []
      this.logger.message(this.constructor.name, 'setAnimation', 'gift animation destroy')
    }
  }

  /**
   * ギフトアニメーションを描画する
   */
  setAnimation(request: GiftAnimationReq) {
    // 配信開始前の場合はアニメーション表示はしない
    if (this.liveStatus !== 'ON_AIR') {
      return
    }
    // 前のアニメーションが再生中は待機配列に格納して順番に再生
    if (this.isAnimationProcessing) {
      this.waitGiftQueue.push(request)
      this.nextAnimation = (gift: GiftAnimationReq) => {
        this.setAnimation(gift);
      };
      return;
    }
    this.giftInfo = request
    if (request.labelColorNumber === 1) {
      this.labelColor = 'linear-gradient(to bottom right, #EA45B8, #F74457)'
    } else if (request.labelColorNumber === 2) {
      this.labelColor = 'linear-gradient(to bottom right, #F5804C, #FAC054)'
    } else {
      this.labelColor = 'linear-gradient(to bottom right, #86DC67, #54D3A5)'
    }
    this.animationOptions = {
      ...this.animationOptions,
      path: request.path,
    }
    this.isFadeOut = false
    this.isAnimationProcessing = true
  }

  /**
   * アニメーションが生成されたら発火するイベント。
   */
  animationCreated(animationItem: AnimationItem): void {
    this.animationItem = animationItem
  }

  /**
   * アニメーションが1回再生され終わった後に発火するイベント
   * 再生停止する
   */
  onLoopComplete() {
    // アニメーションを停止する
    this.ngZone.runOutsideAngular(() => {
      this.animationItem.stop()
      this.isFadeOut = true
    })
    setTimeout(() => {
      this.isAnimationProcessing = false
      this.animationItem.destroy();
      if (this.nextAnimation) {
        const gift = this.waitGiftQueue.shift()
        this.nextAnimation(gift)
        this.logger.message(this.constructor.name, 'setAnimation', 'gift end')
      }
    }, 200)
  }
}
